import { ReadonlyURLSearchParams } from 'next/navigation';

import { isInvalidStoreQueryValue } from 'utils/bookingSearchParams';

import { SearchParameters, ShopCartItem } from 'types';

export const getPackagesParameters = (
  searchParams: ReadonlyURLSearchParams
): { packages: string[] | null; store: string | null } => {
  const packagesParams = searchParams.get(SearchParameters.Packages);
  const rawStore = searchParams.get(SearchParameters.Store);
  const storeParams =
    rawStore != null && !isInvalidStoreQueryValue(rawStore) ? rawStore : null;

  const getServices = (): string[] | null => {
    if (!packagesParams) return null;

    if (packagesParams?.includes(',')) {
      return packagesParams.split(',');
    }

    return [packagesParams];
  };

  return { packages: getServices(), store: storeParams };
};

export const getAvailableShipment = (item: ShopCartItem) =>
  Boolean(item.is_shippable);
